import Ajax from '../ajax';

const controller = 'appAdvertisement';
export default {
  list: (data, blockType) => Ajax('get', `${controller}/${blockType}`, data),
  get: (id, blockType) => Ajax('get', `${controller}/${blockType}/${id}`),
  create: (data, blockType) => Ajax('post', `${controller}/${blockType}`, data),
  update: (id, data, blockType) => Ajax('put', `${controller}/${blockType}/${id}`, data),
  enable: (id, blockType) => Ajax('put', `${controller}/${blockType}/${id}/enable`),
  disable: (id, blockType) => Ajax('put', `${controller}/${blockType}/${id}/disable`),
  delete: (id, blockType) => Ajax('delete', `${controller}/${blockType}/${id}`),
};
